/* jshint esversion: 8 */
define([
  "underscore",
  "jquery",
  "config",
  "supportedProducts",
  "util",
  "dojo/i18n!nls/cloudCenterStringResource",
  "dojo/string",
  "templates/computeResourceCollections/matlab/collection",
  "templates/computeResourceCollections/parallelServer/collection",
  "templates/computeResourceCollections/productionServer/collection",
  "templates/computeResourceCollections/webAppServer/collection",
  "templates/computeResourceCollections/licenseManager/collection",
  "templates/computeResourceCollections/cloudNetwork/collection"
], function (_, $, Config, SupportedProducts, Util, I18NStringResource,
             DojoString, MatlabTemplate,
             ParallelServerTemplate, ProductionServerTemplate,
             WebAppServerTemplate, LicenseManagerTemplate,
             CloudNetworkTemplate) {

   const PRODUCT_TEMPLATES = {
     'matlab': MatlabTemplate,
     'parallel_server': ParallelServerTemplate,
     'production_server': ProductionServerTemplate,
     'web_app_server': WebAppServerTemplate,
     'license_manager': LicenseManagerTemplate,
     'cloud_network': CloudNetworkTemplate
   };

   const GET_PRODUCT_TEMPLATE = (product) => {
    let template = null;
    const products = SupportedProducts.getProductNameList();
    if (products.includes(product) && (product) in PRODUCT_TEMPLATES) {
      template = PRODUCT_TEMPLATES[product];
    }
    return template;
  };

  class ProductUIGenerator {
    constructor() {
      this.credentialData = null;
    }

    generateProductHTML (product, templateParams = {}) {
      if (!product || typeof product !== 'string') {
        throw new TypeError('Invalid product argument');
      }
      let productTableHTML = "";
      const template = GET_PRODUCT_TEMPLATE(product);
      if (template) {
        productTableHTML = template(templateParams);
      }
      return productTableHTML;
    }

    getProductsHTML (products) {
      if (!products) {
        throw new TypeError("Invalid products argument");
      }
      let productsHTML = "";
      const supportedProductNames = SupportedProducts.getProductNameList();
      /* istanbul ignore next */
      for (let product of supportedProductNames) {
        if (products[product]) {
          const templateParams = {
            i18n: I18NStringResource,
            availableProducts: products,
          };
          const productHTML = this.generateProductHTML(product, templateParams);
          productsHTML += productHTML;
        }
      }
      return productsHTML;
    }

    getCredentialData () { return this.credentialData; }
    setCredentialData (data) {
      if (data && typeof data === "object" && typeof data.credentials === 'object') {
        this.credentialData = data;
      } else {
        this.credentialData = null;
      }
    }



  }
  return ProductUIGenerator;
});
